"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Friday",
    "MONDAY": "Monday",
    "SATURDAY": "Saturday",
    "SUNDAY": "Sunday",
    "THURSDAY": "Thursday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "and": "and",
    "day": "day",
    "day_one": "day",
    "day_other": "days",
    "day_plural": "days",
    "freeOfCharge": "Free of Charge",
    "hour_one": "hour",
    "hour_one_plural": "hours",
    "hour_other": "hours",
    "minute": "minute",
    "minute_one": "minute",
    "minute_other": "minutes",
    "ocpiRestrictionsAfterDuration": "After {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Between {{minDuration}} and {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "First {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "When energy consumption above {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "When energy consumption between {{minKwh}} and {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "When energy consumption less than {{maxKwh}}",
    "session": "session",
    "theDay": "day",
    "theDay_one": "day",
    "theDay_other": "days",
    "theHour": "hour",
    "theHour_one": "hour",
    "theHour_other": "hours",
    "theMinute": "minute",
    "theMinute_one": "minute",
    "theMinute_other": "minutes"
};
